<template>
  <div>
    <b-modal
      id="gift-card-success"
      ref="gift-card-success"
      hide-footer
      hide-header
      no-close-on-backdrop
      centered
    >
      <div class="text-center" style="font-family: Open Sans">
        <!-- Success Icon -->
                <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 100 125"
                style="enable-background: new 0 0 100 125"
                xml:space="preserve"
                height="80"
                width="80"
                fill="#1b9142"
                class="succes-svg-padding"
                >
                <g>
                    <g>
                    <path
                        d="M50.2,99.7c-27,0-49-21.9-49-48.9S23.2,2,50.2,2s49,21.9,49,48.9S77.2,99.7,50.2,99.7z M50.2,7.1
    C26,7.1,6.4,26.7,6.4,50.8S26,94.6,50.2,94.6S94.1,75,94.1,50.8S74.4,7.1,50.2,7.1z"
                    />
                    </g>
                    <g>
                    <polygon
                        points="47.4,69.2 29,52.3 32.5,48.5 46.6,61.4 67,31.7 71.3,34.7 		"
                    />
                    </g>
                </g>
                </svg>

        <!-- Message -->
        <p class="mt-3 canpay-crew-text-font-14 canpay-crew-text-600">{{ textMessage || 'Gift card purchased successfully!' }}</p>

        <!-- Actions -->
        <!-- <div class="mt-4 d-flex justify-content-center">
          <button class="btn btn-primary mr-2" @click="onBuyMore">Buy More Gift Cards</button>
          <button class="btn btn-outline-secondary" @click="onGoHome">Return to Home Page</button>
        </div> -->
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'GiftCardSuccess',
  props: {
    textMessage: {
      type: String,
      default: 'Gift card purchased successfully!'
    }
  },
  methods: {
    showSuccessModal() {
      if (this.$refs['gift-card-success']) {
        this.$refs['gift-card-success'].show();
      }
      setTimeout(()=>{
        this.hide();
      },3000)
    },
    hide() {
      if (this.$refs['gift-card-success']) {
        this.$refs['gift-card-success'].hide();
      }
    },
    onBuyMore() {
      this.$emit('buy-more');
      this.hide();
    },
    onGoHome() {
      this.$emit('go-home');
      this.hide();
    }
  }
}
</script>

<style scoped>
</style>

